import { Page } from 'components/Page';
import { PageHeader } from 'components/PageHeader';
import { View } from 'react-native';

export const TasksAssignedListScreen: React.FC = () => {
  return (
    <View style={{ position: 'relative', flex: 1 }}>
      <Page
        header={
          <PageHeader
            title="My Tasks"
            subtitle="15 open • 12 in progress • 3 completed"
          />
        }
      ></Page>
    </View>
  );
};
